import React from 'react'
import styled, {css} from 'styled-components'

const Container = styled.div(({theme:{ colors }}) => css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16rem;
    margin: 2rem 1rem;
    max-width: 16rem;
    background-color: ${colors.grey700};
    cursor: pointer;
    overflow: hidden;
    height: 16rem;
    & > video {
        width: 100%;
        height: fit-content;
    }
`)

const VideoViewer = ({src}) => {

    return (
        <Container>
            {src && (
                <video
                    src={src}
                    controls
                    muted={false}
                    preload='metadata'
                    disablePictureInPicture
                    controlsList='nofullscreen nodownload noremoteplayback'
                />
            )}
        </Container>
    )
}

export { VideoViewer };